// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/aivo lp 2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 200% 200%;
    background-position: center;
    backface-visibility: hidden;
    padding: 40px;
}

.footer-column {
    flex: 1 1;
    width: 100%;
    margin: 0 10px;
    margin-left: 10px;
    margin-right: 10px;
    padding-left: 10px;
    padding-right: 10px;
    height: 340px;
    border-left: 1px solid #ccc;
    
    /* display: flex;
    flex-direction: column; */
    /* text-align: center; */
}

.vertical-line {
    height: 300px;
    /* Adjust the height as needed */
    width: 1px;
    background-color: #ccc;
    display: none;
    /* Adjust the color as needed */
}
.book-button{
    padding: 24px 30px 20px;
    font-size: 14px;
    letter-spacing: 2px;
    background-color: #f39200;
    font-weight: 700;
    margin-bottom: 50px;
}
.text-footer{
    /* font-family: sans-serif; */
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0;
    font-weight: 600;
    color: #f4f4f4;
    text-transform: uppercase;
}
.last-part{
    margin-top: -140px;
}
.myspan{
    border-bottom: 1px solid black;
        /* Adjust the color and thickness as needed */
    display: inline-block;
        /* Ensures that the border only spans the width of the text */
    padding-bottom: 2px;
}
.div-text{
    font-weight: bold;
    font-size: 15px;
}
/* @media (max-width: 1000px) {
    .footer{
        flex-direction: column;
        padding: 20px;
    }
    .vertical-line{
        display: none;
    }
    .last-part{
        margin-top: 20px;
    }
} */
@media (max-width: 1250px) {
    .footer {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 20px;
        padding: 20px;
    }

    .vertical-line {
        display: none;
    }

    .last-part {
        margin-top: 20px;
    }
}
@media (max-width: 800px) {
    .footer {
        display: grid;
        grid-template-columns: 1fr ;
        gap: 20px;
        padding: 20px;
    }

    .vertical-line {
        display: none;
    }

    .last-part {
        margin-top: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Home/Footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,yDAAkD;IAClD,0BAA0B;IAC1B,2BAA2B;IAE3B,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;;IAE3B;6BACyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,8BAA8B;QAC1B,6CAA6C;IACjD,qBAAqB;QACjB,6DAA6D;IACjE,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;;;;;;;;;;;GAWG;AACH;IACI;QACI,aAAa;QACb,kCAAkC;QAClC,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,aAAa;QACb,2BAA2B;QAC3B,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    background-image: url(\"../Images/aivo\\ lp\\ 2.png\");\n    background-size: 200% 200%;\n    background-position: center;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    padding: 40px;\n}\n\n.footer-column {\n    flex: 1;\n    width: 100%;\n    margin: 0 10px;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n    height: 340px;\n    border-left: 1px solid #ccc;\n    \n    /* display: flex;\n    flex-direction: column; */\n    /* text-align: center; */\n}\n\n.vertical-line {\n    height: 300px;\n    /* Adjust the height as needed */\n    width: 1px;\n    background-color: #ccc;\n    display: none;\n    /* Adjust the color as needed */\n}\n.book-button{\n    padding: 24px 30px 20px;\n    font-size: 14px;\n    letter-spacing: 2px;\n    background-color: #f39200;\n    font-weight: 700;\n    margin-bottom: 50px;\n}\n.text-footer{\n    /* font-family: sans-serif; */\n    font-size: 22px;\n    line-height: 28px;\n    letter-spacing: 0;\n    font-weight: 600;\n    color: #f4f4f4;\n    text-transform: uppercase;\n}\n.last-part{\n    margin-top: -140px;\n}\n.myspan{\n    border-bottom: 1px solid black;\n        /* Adjust the color and thickness as needed */\n    display: inline-block;\n        /* Ensures that the border only spans the width of the text */\n    padding-bottom: 2px;\n}\n.div-text{\n    font-weight: bold;\n    font-size: 15px;\n}\n/* @media (max-width: 1000px) {\n    .footer{\n        flex-direction: column;\n        padding: 20px;\n    }\n    .vertical-line{\n        display: none;\n    }\n    .last-part{\n        margin-top: 20px;\n    }\n} */\n@media (max-width: 1250px) {\n    .footer {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr;\n        gap: 20px;\n        padding: 20px;\n    }\n\n    .vertical-line {\n        display: none;\n    }\n\n    .last-part {\n        margin-top: 20px;\n    }\n}\n@media (max-width: 800px) {\n    .footer {\n        display: grid;\n        grid-template-columns: 1fr ;\n        gap: 20px;\n        padding: 20px;\n    }\n\n    .vertical-line {\n        display: none;\n    }\n\n    .last-part {\n        margin-top: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
